export default {
    props: {
        uploadToken: {
            type: String,
        },
        uploadUrl: {
            type: String,
            default: '{apiUrl}/upload/token/{token}',
        },
    },
    data () {
        return {
            fileUpload_succeed: !!this.value,
            xhr: null,
        };
    },
    methods: {
        fileUpload_send (input) {
            if (this.xhr) {
                this.xhr.abort();
            }

            if (!input || input.length === 0) {
                return;
            }

            this.xhr = new XMLHttpRequest();
            this.xhr.open('PUT', this.url);
            this.xhr.onreadystatechange = () => {
                if (this.xhr.readyState !== 4) {
                    return;
                }

                if (this.xhr.status === 200) {
                    this.fileUpload_succeed = true;
                    if (typeof (this.validation_changed) === 'function') {
                        this.validation_changed();
                    }
                }

                this.xhr = null;
            };

            let form = new FormData();
            if (form.set) {
                form.set('file', input);
            } else {
                form.append('file', input);
            }
            this.xhr.send(form);
        },
    },
    computed: {
        url () {
            return this.uploadUrl.replace('{token}', this.uploadToken).replace('{apiUrl}', this.$root.appConfig.apiUrl);
        },
        fileUpload_inProgress () {
            return this.xhr ? this.$trl('aw.upload_in_progress') : false;
        },
        fileUpload_failed () {
            return this.uploadToken && !this.xhr && !this.fileUpload_succeed && this.input;
        },
    },
};
